"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactAvatar = _interopRequireDefault(require("react-avatar"));
var _Menu = _interopRequireDefault(require("@mui/material/Menu"));
var _MenuItem = _interopRequireDefault(require("@mui/material/MenuItem"));
var _system = require("@mui/system");
var _Text = _interopRequireDefault(require("../Text"));
var _theme = require("../../theme");
var _i18n = _interopRequireDefault(require("../../localization/i18n"));
var _tokens = _interopRequireDefault(require("../../localization/tokens"));
/* eslint-disable arrow-body-style */

var StyledMenuItem = (0, _system.styled)(_MenuItem["default"])({
  height: 'auto',
  justifyContent: 'center',
  minWidth: '100%',
  padding: '5px',
  paddingTop: '10px'
});
var TopMenuItem = (0, _system.styled)("div")({
  padding: '30px',
  paddingTop: '20px',
  textAlign: 'center'
});
var StyledMenu = (0, _system.styled)(_Menu["default"])({
  '& .MuiPaper-root': {
    borderRadius: 8,
    minWidth: 240
  }
});

/**
 *
 * @param {*} param0
 */
var MetaMenu = function MetaMenu(_ref) {
  var open = _ref.open,
    onClose = _ref.onClose,
    isAdvisorSite = _ref.isAdvisorSite,
    isMemberSite = _ref.isMemberSite,
    isMasterSite = _ref.isMasterSite,
    anchorEl = _ref.anchorEl,
    toggleModal = _ref.toggleModal,
    handleCloseMenu = _ref.handleCloseMenu,
    logout = _ref.logout,
    name = _ref.name,
    email = _ref.email,
    testid = _ref.testid;
  var theme = (0, _system.useTheme)();
  return /*#__PURE__*/_react["default"].createElement(StyledMenu, {
    anchorEl: anchorEl,
    open: open,
    onClose: onClose,
    disableAutoFocusItem: true,
    anchorOrigin: {
      vertical: "top",
      horizontal: "left"
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      borderBottom: "".concat(_theme.colors.surface, " solid 1px")
    },
    onClick: handleCloseMenu
  }, /*#__PURE__*/_react["default"].createElement(TopMenuItem, null, /*#__PURE__*/_react["default"].createElement(_reactAvatar["default"], {
    name: name,
    size: "55",
    textSizeRatio: 2.2,
    round: false,
    color: theme.palette.primary.main,
    style: {
      marginBottom: 20
    }
  }), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    testid: testid,
    align: 'center',
    medium: true,
    bold: true,
    display: "block",
    customStyle: {
      lineHeight: "22.88px"
    }
  }, name), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    align: 'center',
    medium: true,
    light: true,
    display: "block"
  }, email))), isMemberSite && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(StyledMenuItem, {
    onClick: handleCloseMenu
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    margin: "0 10px",
    display: "block",
    link: "/my-account",
    customLinkStyle: {
      textDecoration: 'none'
    }
  }, _i18n["default"].t(_tokens["default"].titles["my account"]))), /*#__PURE__*/_react["default"].createElement(StyledMenuItem, {
    onClick: handleCloseMenu
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    margin: "0 10px",
    display: "block",
    link: "/resources",
    customLinkStyle: {
      textDecoration: 'none'
    }
  }, _i18n["default"].t(_tokens["default"].titles.resources))), /*#__PURE__*/_react["default"].createElement(StyledMenuItem, {
    onClick: handleCloseMenu
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    margin: "0 10px",
    display: "block",
    onClick: function onClick() {
      return window.FreshworksWidget('open');
    },
    customLinkStyle: {
      textDecoration: 'none'
    }
  }, _i18n["default"].t(_tokens["default"].titles.help)))), isAdvisorSite && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(StyledMenuItem, {
    onClick: function onClick() {
      return toggleModal(isAdvisorSite ? 'showAdvisorSettingsModal' : 'showAdminSettingsModal');
    }
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    align: "center",
    medium: true,
    display: "block",
    customLinkStyle: {
      textDecoration: 'none'
    }
  }, "Settings")), /*#__PURE__*/_react["default"].createElement(StyledMenuItem, {
    onClick: function onClick() {
      return toggleModal('showPasswordModal');
    }
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    align: "center",
    medium: true,
    display: "block",
    customLinkStyle: {
      textDecoration: 'none'
    }
  }, "Change Password"))), isMasterSite && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(StyledMenuItem, {
    onClick: function onClick() {
      return toggleModal('showBankingDetailsModal');
    }
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    align: "center",
    medium: true,
    display: "block",
    customLinkStyle: {
      textDecoration: 'none'
    }
  }, "Banking Details")), /*#__PURE__*/_react["default"].createElement(StyledMenuItem, {
    onClick: handleCloseMenu
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    margin: "0 10px",
    display: "block",
    link: "/billing",
    customLinkStyle: {
      textDecoration: 'none'
    }
  }, "Billing")), /*#__PURE__*/_react["default"].createElement(StyledMenuItem, {
    onClick: handleCloseMenu
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    margin: "0 10px",
    display: "block",
    link: "/administrators",
    customLinkStyle: {
      textDecoration: 'none'
    }
  }, "Administrators")), /*#__PURE__*/_react["default"].createElement(StyledMenuItem, {
    onClick: handleCloseMenu
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    align: "center",
    medium: true,
    display: "block"
  }, "Resources")), /*#__PURE__*/_react["default"].createElement(StyledMenuItem, {
    onClick: handleCloseMenu
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    align: "center",
    medium: true,
    display: "block"
  }, "Contact Support"))), /*#__PURE__*/_react["default"].createElement(StyledMenuItem, {
    onClick: logout
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    color: _theme.colors.red,
    align: "center",
    medium: true,
    display: "block"
  }, _i18n["default"].t(_tokens["default"].titles.logout))));
};
var _default = exports["default"] = MetaMenu;